import { authorizedFetch } from '../../helpers/authorizedFetch'
import { formatDate } from '../../helpers/date'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import getIncluded from '../../japi/getIncluded'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { DateFormat } from '../../types/dateFormatTypes'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { Period } from '../Period/Period'
import { UserResource } from '../User/User'
import { transformToUser } from '../User/UserTransformers'
import { UnavailableToWorkTimeSlot, UnavailableToWorkTimeSlotResource } from './UnavailableToWorkTimeSlot'
import { transformToUnavailableToWorkTimeSlot } from './UnavailableToWorkTimeSlotTransformers'

export const getUnavailableToWorkTimeSlotsApiCall = async (period: Period): Promise<FetchCollectionResult<UnavailableToWorkTimeSlot[], string>> => {
    try {
        const includes = ['user']

        const url = generateApiUrl({
            endpoint: '/unavailable-to-work-time-slots',
            queryParams: {
                startDate: formatDate(period.start, DateFormat.apiDateTime),
                endDate: formatDate(period.end, DateFormat.apiDateTime),
                include: includes.join(','),
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<UnavailableToWorkTimeSlotResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const unavailableToWorkTimeSlots = doc.data.map(unavailableToWorkTimeSlot => {
            const userResource = getIncluded(doc, unavailableToWorkTimeSlot, 'user') as UserResource
            const user = transformToUser(userResource)

            return transformToUnavailableToWorkTimeSlot(unavailableToWorkTimeSlot, user)
        })

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: unavailableToWorkTimeSlots,
        }
    } catch (error) {
        console.error('[getUnavailableToWorkTimeSlotsApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
